export { default } from './error-page-404';
